export default __webpack_public_path__ + "static/media/India.621869c6.png";